// Add your custom JS here.

document.addEventListener('DOMContentLoaded', function () {
  var breakpoint = 1200;
  var lastWidth = window.innerWidth;

  window.addEventListener('resize', function () {
    var currentWidth = window.innerWidth;

    // PC幅 ⇔ モバイル幅 の境界線を跨いだときのみ処理を実行
    if ((lastWidth >= breakpoint && currentWidth < breakpoint) || 
        (lastWidth < breakpoint && currentWidth >= breakpoint)) {
      
      // 開いているドロップダウンの .show クラスをすべて解除して閉じ直す
      var dropdowns = document.querySelectorAll('.navbar-nav .dropdown, .navbar-nav .dropdown-menu, .navbar-nav .dropdown-toggle');
      dropdowns.forEach(function (el) {
        el.classList.remove('show');
        if (el.hasAttribute('aria-expanded')) {
          el.setAttribute('aria-expanded', 'false');
        }
      });
    }

    lastWidth = currentWidth;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // 1. 子メニューのリンク（.dropdown-item）
  // 2. 親メニューのうち、ドロップダウントグル（矢印）ではない通常のリンク（.nav-link:not(.dropdown-toggle)）
  const menuLinks = document.querySelectorAll('.navbar-nav .dropdown-item, .navbar-nav .nav-link:not(.dropdown-toggle)');

  menuLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      // モバイルサイズ（1199px以下）の時のみ実行
      if (window.innerWidth <= 1199) {
        
        // ① 開いているドロップダウン（子メニュー）を閉じる
        const openDropdowns = document.querySelectorAll('.navbar-nav .show');
        openDropdowns.forEach(function (el) {
          el.classList.remove('show');
        });

        const openToggles = document.querySelectorAll('.navbar-nav [aria-expanded="true"]');
        openToggles.forEach(function (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        });

        // ② ハンバーガーメニュー本体（アコーディオン全体）を閉じる
        const navbarCollapse = document.querySelector('.navbar-collapse');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
          if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
            const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse) || new bootstrap.Collapse(navbarCollapse);
            bsCollapse.hide();
          } else {
            navbarCollapse.classList.remove('show');
          }
        }

      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {

    const items = document.querySelectorAll('.album-page .gallery-item');

    items.forEach(function (item) {

        item.addEventListener('click', function () {

            openModal(this);

        });

    });
    
    function openModal(element) {
      const modal = document.getElementById('imageModal');
      const modalImg = document.getElementById('modalImg');
      const imgSrc = element.querySelector('img').src;
      
      modalImg.src = imgSrc;
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
});

document.addEventListener('DOMContentLoaded', function () {

    const modal = document.getElementById('imageModal');
    const closeButton = modal.querySelector('.modal-close');

    // モーダルの背景をクリックしたら閉じる
    modal.addEventListener('click', function (event) {

        if (event.target === modal) {
            closeModal(event);
        }

    });
    
    // ×ボタンをクリックしたら閉じる
    closeButton.addEventListener('click', function (event) {

        closeModal(event);

    });
    
    function closeModal(event) {
      if (event.target.id === 'modalImg') return;
      
      const modal = document.getElementById('imageModal');
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
});


